import { Paragraph } from 'tamagui';
import { formatRemaining } from '../../lib/chat-view';
import type { ChatQuota } from '../../lib/api';

// At or below this many remaining questions the meter turns amber (DESIGN.md's
// status warning $orange10) — informative "running low", never a paywall nag.
// Includes remaining = 0 (the composer owns the blocked-state message).
const NEAR_QUOTA_THRESHOLD = 5;

/** Header meter: "{remaining} of {limit} questions left today". */
export function QuotaMeter({ quota }: { quota: ChatQuota | undefined }) {
  if (!quota) return null;
  const nearQuota = quota.remaining <= NEAR_QUOTA_THRESHOLD;
  return (
    <Paragraph size="$2" color={nearQuota ? '$orange10' : '$color10'} fontWeight="600">
      {formatRemaining(quota)}
    </Paragraph>
  );
}
